import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '../../shared/services/http.service';
import { BoxGateway, RebootBoxCommand } from '../models/BoxGateway';
import { Execution } from '../models/Execution';

@Injectable({ providedIn: 'root' })
export class HttpBoxGateway implements BoxGateway {
    private readonly httpService = inject(HttpService);

    reboot({ device, sessionId }: RebootBoxCommand): Observable<Execution> {
        return this.httpService.patch('/v1/device', {
            device: {
                id: device.id,
                type_id: device.type_id,
                deviceurl: device.deviceurl,
                protocol_profile: device.protocol_profile,
                categories: device.categories,
                definition: device.definition,
                site_id: device.site_id,
                type: device.type,
            },
            command: { speAction: 'reboot' },
            sessionId,
        });
    }
}
